import { FC, useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
} from "@ht/components";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import Dots from "@ht/shared/fonts/deos-pis/dots";
import clsx from "clsx";
import DropdownMessageControlItem from "../../../components/dropdown/message/item";
import CloseIcon from "@ht/shared/fonts/deos-pis/close";
import DeleteIcon from "@ht/shared/fonts/deos-pis/trash";
import { MessageBox } from "../../../components/message-box";
import { useNavigate } from "react-router-dom";
import { activeChatAgentRoom, resolveAgentRoom } from "../../../app/chatAgent/chatAgentSlice"
import { IActiveRoom } from "../../../app/chatAgent/types";
import { RootState } from "../../../app/store";

const MessageOptions: FC = () => {
  const dispatch = useAppDispatch();
  const { activeRoom, layoutType } = useAppSelector((state) => state.chatagent);
  const userRole = useAppSelector((state: RootState) => state.auth.user?.cmRoleName);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [message, setMessage] = useState("");
  const closeMessageBoxHandler = () => {
    setShowMessageBox((prev) => !prev);
    setMessage("");
  };

  const navigate = useNavigate()
  const handleCloseOnClick = () => {
    if (layoutType == "PAGE") navigate("/chat");
    dispatch(activeChatAgentRoom({} as IActiveRoom));
  }

  const endChatHandler = () => {
    if (layoutType == "PAGE") navigate("/chat");
    dispatch(activeChatAgentRoom({} as IActiveRoom));
    const resolveChatObj = {
      sessionId: activeRoom.sessionId
    }
    dispatch(resolveAgentRoom(resolveChatObj))
  }

  const isRemoveDisabled = () => userRole === 'AGENT';
  
  return (
    <>
      <MessageBox
        type="warning"
        visible={showMessageBox}
        closeHandler={closeMessageBoxHandler}
        title="Warning"
        message={message}
      />
      <div className="flex items-center ml-auto">
        <div className="sm:flex">
          <Dropdown
            className="mr-3 block"
            direction="down"
            showIcon={false}
            shape
          >
            <DropdownToggle
              variant="texted"
              iconButton
              size="lg"
              shape="ellipse"
              customStyle="only-icon"
              className="text-[26px] w-[32px] h-[32px] pl-1 relative content-start"
            >
              <Dots className={clsx("w-6 h-6 text-gray-400")} />
            </DropdownToggle>
            <DropdownMenu
              className={clsx(
                "rounded p-0 mt-[1.125rem] -mr-[1.2rem] border-t-0 right-0 left-auto"
              )}
            >
              <button className="dropdown-list rounded-b flex items-center px-1.5 text-gray-700"
                onClick={handleCloseOnClick}
              >
                <DropdownMessageControlItem
                  additionalClass="rounded-t text-gray-700 font-semibold"
                  text="Close"
                  IconSvg={CloseIcon}
                />
              </button>
              <button
                disabled={isRemoveDisabled()}
                className="dropdown-list rounded-b flex items-center px-1.5 ">
                <DropdownMessageControlItem
                  onClick={endChatHandler}
                  additionalClass={"rounded-b font-semibold " + (isRemoveDisabled() ? "text-red-200" : "text-red-900")}
                  text="Remove"
                  IconSvg={DeleteIcon}
                />
              </button>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </>
  );
};

export default MessageOptions;
